// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__RsVE4","empty":"ModalGraph_empty__3U1Y1"};